export class Constants {
  static readonly DATE_FORMAT_HTML = 'YYYY-MM-dd';
  static readonly DATE_FORMAT = 'dd.MM.yyyy';
  static readonly DATE_TIME_FORMAT = 'dd.MM.yyyy; HH:mm';
  static readonly DATE_TIME_FULL_FORMAT = 'dd.MM.yyyy; HH:mm';
}
